import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const initialState = {
  pickUp: {
    contactName: '',
    contactNumber: '',
    locationDetail: '',
  },
  destination: {
    contactName: '',
    contactNumber: '',
    locationDetail: '',
  },
}
const locationInfoSlice = createSlice({
  name: 'ports',
  initialState,
  reducers: {
    updateLocationInfo: (state: any, action: PayloadAction<any>) => {
      if (action.payload.isPickUp) state.pickUp = action.payload.info
      else state.destination = action.payload.info
    },
    resetLocationInfo: (state: any, action: PayloadAction<any>) => {
      if (action.payload.isPickUp) state.pickUp = initialState.pickUp
      else state.destination = initialState.destination
    },
  },
})
export const locationInfoAction = locationInfoSlice.actions
export default locationInfoSlice
